import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { css } from '../../../styled-system/css';
import { catchError } from '../../errors/utils/handleError';
import { useAuth } from '../hooks/useAuth';

export const Logout = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!auth.uid) {
      navigate('/');
    }

    new Promise((resolve) => {
      setTimeout(resolve, 1000);
    })
      .then(() => {
        return auth.signOut();
      })
      .catch(catchError);
  }, [navigate, auth]);

  return (
    <div className={css({ margin: '12', textAlign: 'center' })}>
      Signing you out...
    </div>
  );
};
